import { Checkbox as AntCheckbox, CheckboxProps as AntCheckboxProps } from 'antd';
import { ChangeEvent, forwardRef, MutableRefObject, Ref } from 'react';

export interface CheckboxProps extends Omit<AntCheckboxProps, 'onChange'> {
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  inputRef?: Ref<HTMLInputElement>;
  inputProps?: Record<string, unknown>;
  color?: string;
  size?: 'small' | 'middle' | 'large' | string;
  disableRipple?: boolean;
  icon?: React.ReactNode;
  checkedIcon?: React.ReactNode;
  indeterminateIcon?: React.ReactNode;
}

function assignRef(ref: Ref<HTMLInputElement> | undefined, value: HTMLInputElement | null) {
  if (!ref) {
    return;
  }

  if (typeof ref === 'function') {
    ref(value);
    return;
  }

  (ref as MutableRefObject<HTMLInputElement | null>).current = value;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  {
    onChange,
    inputRef,
    inputProps: _inputProps,
    color: _color,
    disableRipple: _disableRipple,
    icon: _icon,
    checkedIcon: _checkedIcon,
    indeterminateIcon: _indeterminateIcon,
    size: _size,
    className,
    style,
    ...props
  },
  ref,
) {
  void _inputProps;
  void _color;
  void _disableRipple;
  void _icon;
  void _checkedIcon;
  void _indeterminateIcon;
  void _size;

  return (
    <AntCheckbox
      {...props}
      className={['inline-flex min-h-10 min-w-10 items-center justify-center', className].filter(Boolean).join(' ')}
      style={{
        ...style,
        transform: 'scale(1.2)',
        transformOrigin: 'center',
      }}
      onChange={event => {
        onChange?.(
          {
            target: {
              checked: event.target.checked,
              value: event.target.value,
              name: props.name,
            },
          } as ChangeEvent<HTMLInputElement>,
          event.target.checked,
        );
      }}
      ref={node => {
        const input = node?.input ?? null;
        assignRef(ref, input);
        assignRef(inputRef, input);
      }}
    />
  );
});
